// 'jsx-closing-bracket-location': 1
import React from 'react';
import PropTypes from 'prop-types';
import CurrencyInput from 'react-currency-input-field';

// eslint-disable-next-line no-unused-vars
import currencycss from './currency.css';

function StaticCurrencyInput({ title, value, errorMessage, className, label }) {
  const id = title || 'currency-' + value;
  return (
    <div>
      <header htmlFor={title} id={id}>
        {title}
      </header>

      <CurrencyInput
        name={title}
        prefix="$ "
        disabled
        className={'currency-input static ' + className}
        allowNegativeValue={false}
        defaultValue={value}
        decimalsLimit={2}
        decimalScale={2}
        value={value}
        aria-labelledby={label || id}
        // eslint-disable-next-line react/jsx-closing-bracket-location
      />
      {errorMessage && <p className="error"> {errorMessage} </p>}
    </div>
  );
}

StaticCurrencyInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default StaticCurrencyInput;
